import { render, staticRenderFns } from "./bindMobile.vue?vue&type=template&id=4a32fd4a&scoped=true&"
import script from "./bindMobile.vue?vue&type=script&lang=js&"
export * from "./bindMobile.vue?vue&type=script&lang=js&"
import style0 from "./bindMobile.vue?vue&type=style&index=0&id=4a32fd4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a32fd4a",
  null
  
)

export default component.exports